import type { SVGProps } from "react";

export function TrailforksIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 543.7 470.86" {...props}>
      <path fill="#ffcd00" d="M0,470.86L271.82,0l271.88,470.86H0Z" />
      <path d="M271.82,298.62l-39.71,28.55v105.25h-49.91v-126.55l60.35-43.45V129.09h58.54v133.31l60.35,43.45v126.55h-49.91v-105.25l-39.71-28.55h0Z" />
    </svg>
  );
}
